import useIsTeamsEnabled from '@/hooks/useIsTeamsEnabled';
import asyncComponentLoader from '@/utils/react/loader';

import OrgSettings from './OrgSettings';

function SettingsWrapper() {
  const isTeamsEnabled = useIsTeamsEnabled();

  if (!isTeamsEnabled) {
    const OldSettings = asyncComponentLoader(() => import('@/pages/Settings'));

    return <OldSettings />;
  }

  return <OrgSettings />;
}

export default SettingsWrapper;
